import React, { useRef, useState, useEffect } from "react";
import PropTypes from "prop-types";
import { useSelector, useDispatch } from "react-redux";
import MaterialModal from "../MaterialModal";
import { hideModal } from "../../../actions/actionCreators";
import h from "../../../helpers";
import validSnowflakeTable from "../../../helpers/snowflakeValidation";
import withModal from "../withModal";
import AudienceRadiusMap from "./AudienceRadiusMap";
import { IconButton, TextField } from "@material-ui/core";
import NumericalTextField from "../../material-components/Misc/NumericalTextField";

const AudienceRadiusModal = ({ isOpen }) => {
    const dispatch = useDispatch();

    const environment = useSelector(state => state.session.environment);

    const [radius, setRadius] = useState(10);
    const [latlng, setLatLng] = useState(null);
    const [circleLatLng, setCircleLatLng] = useState([39.470125122, -5436.562500000001]); //Place it somewhere VERY far off, circle acts weird when it doesn't exist initially
    const [errors, setErrors] = useState({});
    const [zipFileName, setZipFileName] = useState("");
    const [zoom, setZoom] = useState(environment == "ukprod" ? 5 : 4);
    const [position, setPosition] = useState([39.470125122, -5436.562500000001]); //Place it somewhere VERY far off, circle acts weird when it doesn't exist initially
    const [foundLocation, setFoundLocation] = useState("");
    const [zipSearch, setZipSearch] = useState("");
    const [retentionDays, setRetentionDays] = useState(0);

    const isDisabled = !latlng;

    const successContainer = useRef(null);
    const infoContainer = useRef(null);
    const successMessage = useRef(null);

    const enabledFeatures = useSelector(state => state.session.enabledFeatures || []);
    const retentionDaysDefault = useSelector(state => state.session.DataRetentionDaysDefault);
    const hasRetentionFeature = enabledFeatures.includes("table-retention-period");

    useEffect(() => {
        if (hasRetentionFeature) {
            setRetentionDays(retentionDaysDefault);
        }
    }, [retentionDaysDefault, hasRetentionFeature]);

    const resetState = () => {
        setRadius(10);
        setLatLng(null);
        setCircleLatLng([39.470125122, -5436.562500000001]);
        setErrors({});
        setZipFileName("");
        setZoom(4);
        setPosition([39.470125122, -5436.562500000001]);
        setFoundLocation("");
        setZipSearch("");
    };

    const hide = () => {
        resetState();
        dispatch(hideModal("AUDIENCE_RADIUS"));
    };

    const save = () => {
        if (!validate()) {
            return;
        }

        $(successContainer.current).hide();
        $(infoContainer.current).show();

        fetch("/Main/ApplyRadiusFilter", {
            credentials: "same-origin",
            method: "POST",
            headers: {
                "Content-Type": "application/json; charset=utf-8",
            },
            body: JSON.stringify({
                zipFileName,
                latitude: latlng[0],
                longitude: latlng[1],
                radius,
                retentionDays,
            }),
        })
            .then(h.checkStatus)
            .then(h.toJson)
            .then(data => {
                $(infoContainer.current).hide();
                if (!data.success) {
                    throw new Error("Error applying radius filter.");
                }
                $(successContainer.current).show();
                $(successMessage.current).text(
                    "Your radius (zip) file has been successfully created. " + data.numSaved + " zips were saved."
                );
            })
            .catch(error => {
                h.error("Error creating radius file.", error);
            });
    };

    const CallGoogle = () => {
        fetch(
            "https://maps.googleapis.com/maps/api/geocode/json?address=" +
                zipSearch +
                "&sensor=false&key=AIzaSyAJny9h66DpQl3l_s0ISmsmAEDbY1c7uEc",
            {
                credentials: "same-origin",
                method: "POST",
            }
        )
            .then(h.checkStatus)
            .then(h.toJson)
            .then(data => {
                if (data.results.length > 0 && data.status != "ZERO_RESULTS") {
                    if (data.results != null) {
                        setZipSearch(data.results[0].formatted_address);
                    }
                    const location = data.results[0].geometry.location;
                    const e = errors;

                    if (!isNumeric(radius)) {
                        e.Radius = "Please enter a numeric value for radius.";
                        setRadius(10);
                    } else {
                        e.Radius = null;
                    }
                    if (radius == 0) {
                        setRadius(10);
                    }

                    e.Marker = null;
                    e.Zip = null;

                    setFoundLocation(data.results[0].formatted_address);
                    setPosition([location.lat, location.lng]);
                    setCircleLatLng([location.lat, location.lng]);
                    setLatLng([location.lat, location.lng]);
                    setZoom(9);
                    setErrors(e);
                } else {
                    const e = errors;
                    e.Zip = "No results were found.";
                    setFoundLocation("");
                    setPosition([39.470125122, -5436.562500000001]);
                    setCircleLatLng([39.470125122, -5436.562500000001]);
                    setLatLng(null);
                    setErrors(e);
                }
            })
            .catch(() => {
                const e = errors;
                e.Zip = "No results were found.";
                setFoundLocation("");
                setPosition([39.470125122, -5436.562500000001]);
                setCircleLatLng([39.470125122, -5436.562500000001]);
                setLatLng(null);
                setErrors(e);
            });
    };

    const validate = () => {
        const e = {};

        if (!isNumeric(radius)) {
            e.Radius = "Please enter a numeric value for radius.";
        }

        if (!zipFileName) {
            e.zipFileName = "Please enter a name for your radius filter.";
        }

        if (latlng == null) {
            e.Marker = "Please set a marker on the map before submitting.";
        }

        setErrors(e);
        return Object.keys(e).length == 0;
    };

    const isNumeric = n => !isNaN(parseFloat(n)) && isFinite(n);

    const onClick = (_, __, event) => {
        const latlng = event.latLng.toJSON();
        const lat = latlng.lat;
        const lng = latlng.lng;

        fetch(
            "https://maps.googleapis.com/maps/api/geocode/json?latlng=" +
                lat +
                "," +
                lng +
                "&sensor=false&key=AIzaSyAJny9h66DpQl3l_s0ISmsmAEDbY1c7uEc",
            {
                credentials: "same-origin",
                method: "POST",
            }
        )
            .then(h.checkStatus)
            .then(h.toJson)
            .then(data => {
                if (data.results != null) {
                    setZipSearch(data.results[0].formatted_address);
                }
                const e = errors;

                e.Marker = null;
                setErrors(e);
            })
            .catch(() => {
                const e = errors;
                setZipSearch("");
                e.Marker = "No locations were found.";
                setErrors(e);
            });

        setLatLng([lat, lng]);
        setCircleLatLng([lat, lng]);
        setPosition([lat, lng]);

        if (radius == 0) {
            setRadius(10);
        }
    };

    const formatRadius = e => {
        let myVal = e.target.value;

        if (myVal == "" || parseInt(myVal) < 0) {
            myVal = 0;
        }

        setRadius(myVal);
    };

    const formatFileName = e => {
        let pass = false;

        pass = validSnowflakeTable(e.target.value);
        if (pass) {
            setZipFileName(e.target.value);
        }
    };

    return (
        <MaterialModal
            id="radius-modal"
            isOpen={isOpen}
            title="Create a Radius Filter"
            primaryButtonText="Save"
            onAfterOpen={resetState}
            onClose={hide}
            onPrimaryButtonRequest={save}
            maxWidth="lg"
            fullWidth
            isPrimaryButtonDisabled={isDisabled}
        >
            <div>
                <div className="row">
                    <div className="col-sm-6">
                        <TextField
                            className="pull-left form-radius-name"
                            label={"Filter Name"}
                            helperText={errors.zipFileName}
                            error={Boolean(errors.zipFileName)}
                            onChange={e => formatFileName(e)}
                            value={zipFileName}
                            type="text"
                        />
                    </div>
                    <div className="col-sm-2">
                        <NumericalTextField
                            className="pull-left form-radius-miles"
                            label={"Radius (miles)"}
                            helperText={errors.Radius}
                            error={Boolean(errors.Radius)}
                            onBlur={e => formatRadius(e)}
                            value={radius}
                            numberType="decimal"
                        />
                    </div>
                    {hasRetentionFeature && (
                        <div className="col-sm-4">
                            <NumericalTextField
                                id="retentionDays"
                                label="Retention period (Days)"
                                helperText={"* A value of 0 means that the table should never expire."}
                                value={retentionDays}
                                onBlur={e => {
                                    if (e.target.value == "") {
                                        setRetentionDays(null);
                                    } else {
                                        let value = parseInt(e.target.value);
                                        if (value < 0) {
                                            value = 0;
                                        }

                                        setRetentionDays(value);
                                    }
                                }}
                            />
                        </div>
                    )}
                </div>
                <div className="row" style={{ marginTop: "10px" }}>
                    <div className="col-sm-12">
                        <TextField
                            className="pull-left form-radius-search-text"
                            style={{ width: "75%" }}
                            label={"Search for Location"}
                            helperText={errors.Zip}
                            error={Boolean(errors.Zip)}
                            onKeyDown={e => {
                                if (e.nativeEvent.code == "Enter") {
                                    CallGoogle();
                                }
                            }}
                            onChange={e => setZipSearch(e.target.value)}
                            value={zipSearch}
                            type="text"
                        />
                        <IconButton onClick={CallGoogle} color="primary">
                            <span className="material-icons form-radius-search-button">search</span>
                        </IconButton>
                    </div>
                </div>
                <div style={{ marginTop: "10px", height: "350px" }} id="mapContainer">
                    {isOpen && (
                        <AudienceRadiusMap
                            center={latlng}
                            marker={position}
                            circle={circleLatLng}
                            radius={radius * 1609.34} /* multiply to get meters */
                            zoom={zoom}
                            location={foundLocation}
                            showMarker={latlng != null}
                            onClick={onClick}
                        />
                    )}
                </div>
                <div style={{ marginTop: "10px" }}>
                    <label className="control-label" htmlFor="">
                        Found Location:
                    </label>{" "}
                    {foundLocation ? foundLocation : "No location has been found. Please search for a valid location."}
                </div>
                {errors.Marker && <span className="help-block">{errors.Marker}</span>}
                <div className="alert alert-info m-b-0 m-t" ref={infoContainer} style={{ display: "none" }}>
                    <div>Creating radius file.</div>
                </div>
                <div className="alert alert-success m-b-0 m-t" ref={successContainer} style={{ display: "none" }}>
                    <div ref={successMessage} className="radius-success-message">
                        Your radius (zip) file has been successfully created.
                    </div>
                </div>
            </div>
        </MaterialModal>
    );
};

AudienceRadiusModal.propTypes = {
    modalProps: PropTypes.object,
    isOpen: PropTypes.bool,
};

const AudienceRadiusModalConnected = withModal(AudienceRadiusModal, "AUDIENCE_RADIUS");

export default AudienceRadiusModalConnected;
